export default "__VITE_ASSET__4Jz61r9L__"